import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonExplainModule } from '../../common-explain/common-explain.module';

@Component({
  selector: 'modal-job-description',
  templateUrl: './modal-job-description.component.html',
  styleUrls: ['./modal-job-description.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    FormsModule,
    CommonExplainModule
  ]
})
export class ModalJobDescriptionComponent {
  ROLE_CHAR_LIMIT = 1024;
  role = '';

  constructor(
    private activeModal: NgbActiveModal
  ) {
  }

  cancel() {
    this.activeModal.dismiss();
  }

  confirm() {
    this.activeModal.close(this.role.trim().substring(0, this.ROLE_CHAR_LIMIT));
  }
}
